interface HeroProps {
  onContactClick: () => void;
}

export default function Hero({ onContactClick }: HeroProps) {
  return (
    <div className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Gradient - nova paleta azul */}
      <div className="absolute inset-0" style={{ background: 'linear-gradient(135deg, #0a1a4a 0%, #1A3A8F 50%, #0d2060 100%)' }}></div>

      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=professional%20podcast%20studio%20setup%20with%20microphones%20headphones%20and%20modern%20lighting%20equipment%20in%20dark%20ambient%20atmosphere%20with%20blue%20electric%20neon%20lights%20creating%20a%20sophisticated%20broadcasting%20environment%20technology%20innovation%20digital%20media%20production%20workspace%20amazonian%20theme%20blue%20cyan%20glow&width=1920&height=1080&seq=hero-bg-021&orientation=landscape"
          alt="Podcast Studio"
          className="w-full h-full object-cover object-top opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-6xl mx-auto px-6 py-20 text-center w-full">
        {/* Top Badge */}
        <div className="flex justify-center mb-8">
        </div>

        {/* Logo */}
        <div className="flex justify-center mb-8">
          <img
            src="https://static.readdy.ai/image/5da477fdae7b1d111ee386eccbf37db2/5fafdbd9edd70d12c9a9e107c1c2ce01.png"
            alt="Manaus Digital Podcast"
            className="h-24 w-auto"
          />
        </div>

        {/* Main Title */}
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-extrabold text-white mb-6 tracking-tight leading-tight">
          Bem vindo Entrevistado(a) do<br />
          <span style={{ background: 'linear-gradient(90deg, #2B6FD4, #00BFFF, #00D4FF)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }}>
            Manaus Digital Podcast
          </span>
        </h1>

        {/* Subtitle */}
        <p className="text-xl md:text-2xl text-gray-200 mb-12 max-w-3xl mx-auto leading-relaxed">
          Compartilhe sua história com milhares de empreendedores e profissionais da Amazônia
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a
            href="https://www.youtube.com/@manausdigitalpodcast/videos"
            target="_blank"
            rel="noopener noreferrer"
            className="border-2 font-semibold px-8 py-4 rounded-xl transition-all hover:scale-105 whitespace-nowrap cursor-pointer text-white"
            style={{ borderColor: '#00BFFF', color: '#00BFFF' }}
            onMouseEnter={e => { (e.currentTarget as HTMLAnchorElement).style.background = '#00BFFF'; (e.currentTarget as HTMLAnchorElement).style.color = '#0a1a4a'; }}
            onMouseLeave={e => { (e.currentTarget as HTMLAnchorElement).style.background = 'transparent'; (e.currentTarget as HTMLAnchorElement).style.color = '#00BFFF'; }}
          >
            <i className="ri-youtube-line mr-2"></i>
            Ver Episódios no YouTube
          </a>
          <a
            href="https://open.spotify.com/show/4971KjDEiJP4D0htdMG78u"
            target="_blank"
            rel="noopener noreferrer"
            className="border-2 border-white/40 text-white hover:bg-white/10 font-semibold px-8 py-4 rounded-xl transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-spotify-line mr-2"></i>
            Ouvir no Spotify
          </a>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mt-20 max-w-4xl mx-auto">
          <div className="backdrop-blur-md rounded-2xl p-8 border flex flex-col items-center justify-center min-h-[130px]" style={{ background: 'rgba(255,255,255,0.07)', borderColor: 'rgba(0,191,255,0.25)' }}>
            <div className="text-4xl font-bold mb-2" style={{ color: '#00BFFF' }}>4ª</div>
            <div className="text-white font-medium text-base">Temporada</div>
          </div>
          <div className="backdrop-blur-md rounded-2xl p-8 border flex flex-col items-center justify-center min-h-[130px]" style={{ background: 'rgba(255,255,255,0.07)', borderColor: 'rgba(0,191,255,0.25)' }}>
            <div className="text-4xl font-bold mb-2" style={{ color: '#00BFFF' }}>30-60</div>
            <div className="text-white font-medium text-base">Minutos de Episódio</div>
          </div>
          <div className="backdrop-blur-md rounded-2xl p-8 border flex flex-col items-center justify-center min-h-[130px]" style={{ background: 'rgba(255,255,255,0.07)', borderColor: 'rgba(0,191,255,0.25)' }}>
            <div className="text-4xl font-bold mb-2" style={{ color: '#00BFFF' }}>🏆 2x</div>
            <div className="text-white font-medium text-base">Prêmio Jaraqui Graúdo</div>
            <div className="text-gray-400 text-sm mt-1">Veículo de Comunicação do Ecossistema</div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </div>
  );
}
